import { css } from 'styled-components';

import { DialogTheme, SternumTheme } from '@sternum/ui';

import { Colors, Shadows } from '../constants';

export function SBOMLightDialogTheme(theme: SternumTheme): Partial<DialogTheme.DialogTheme> {
  return {
    backgroundColor: Colors.White,
    textColor: theme.textColor,
    boxShadow: Shadows.DialogLightMode,
    backdropColor: 'rgba(36, 36, 36, 0.3)',
    borderRadius: '4px',
    footerPadding: '24px 0',
    footerGap: '8px',
    footerCss: css`
      align-content: center;
      align-items: stretch;
    `,
    closeIconContainerTop: '6px',
    closeIconContainerRight: '6px',
    xIconCss: css`
      width: 24px;
      height: 24px;
    `,
    contentCss: css`
      margin: 24px 0 0 0;
    `,
    containerCss: css`
      min-height: 100px;
      width: min-content;
      z-index: 1000;
    `,
    backdropCss: css`
      z-index: 999;
    `,
  };
}
